// ISO 3166-1 alpha-2 country codes with country names and flags
export interface Country {
  code: string; // ISO 3166-1 alpha-2
  name: string;
  flag: string; // Emoji flag
}

export const COUNTRIES: Country[] = [
  { code: 'IT', name: 'Italia', flag: '🇮🇹' },
  { code: 'FR', name: 'Francia', flag: '🇫🇷' },
  { code: 'ES', name: 'Spagna', flag: '🇪🇸' },
  { code: 'DE', name: 'Germania', flag: '🇩🇪' },
  { code: 'GB', name: 'Regno Unito', flag: '🇬🇧' },
  { code: 'US', name: 'Stati Uniti', flag: '🇺🇸' },
  { code: 'CH', name: 'Svizzera', flag: '🇨🇭' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹' },
  { code: 'PT', name: 'Portogallo', flag: '🇵🇹' },
  { code: 'GR', name: 'Grecia', flag: '🇬🇷' },
  { code: 'NL', name: 'Paesi Bassi', flag: '🇳🇱' },
  { code: 'BE', name: 'Belgio', flag: '🇧🇪' },
  { code: 'SE', name: 'Svezia', flag: '🇸🇪' },
  { code: 'NO', name: 'Norvegia', flag: '🇳🇴' },
  { code: 'DK', name: 'Danimarca', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlandia', flag: '🇫🇮' },
  { code: 'IS', name: 'Islanda', flag: '🇮🇸' },
  { code: 'IE', name: 'Irlanda', flag: '🇮🇪' },
  { code: 'PL', name: 'Polonia', flag: '🇵🇱' },
  { code: 'CZ', name: 'Repubblica Ceca', flag: '🇨🇿' },
  { code: 'HU', name: 'Ungheria', flag: '🇭🇺' },
  { code: 'HR', name: 'Croazia', flag: '🇭🇷' },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴' },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬' },
  { code: 'TR', name: 'Turchia', flag: '🇹🇷' },
  { code: 'EG', name: 'Egitto', flag: '🇪🇬' },
  { code: 'MA', name: 'Marocco', flag: '🇲🇦' },
  { code: 'TN', name: 'Tunisia', flag: '🇹🇳' },
  { code: 'ZA', name: 'Sudafrica', flag: '🇿🇦' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪' },
  { code: 'TZ', name: 'Tanzania', flag: '🇹🇿' },
  { code: 'AE', name: 'Emirati Arabi Uniti', flag: '🇦🇪' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲' },
  { code: 'IL', name: 'Israele', flag: '🇮🇱' },
  { code: 'JO', name: 'Giordania', flag: '🇯🇴' },
  { code: 'JP', name: 'Giappone', flag: '🇯🇵' },
  { code: 'CN', name: 'Cina', flag: '🇨🇳' },
  { code: 'TH', name: 'Thailandia', flag: '🇹🇭' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  { code: 'PH', name: 'Filippine', flag: '🇵🇭' },
  { code: 'KR', name: 'Corea del Sud', flag: '🇰🇷' },
  { code: 'IN', name: 'India', flag: '🇮🇳' },
  { code: 'NP', name: 'Nepal', flag: '🇳🇵' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: 'MV', name: 'Maldive', flag: '🇲🇻' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nuova Zelanda', flag: '🇳🇿' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'MX', name: 'Messico', flag: '🇲🇽' },
  { code: 'BR', name: 'Brasile', flag: '🇧🇷' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
  { code: 'CL', name: 'Cile', flag: '🇨🇱' },
  { code: 'PE', name: 'Perù', flag: '🇵🇪' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺' },
  { code: 'DO', name: 'Repubblica Dominicana', flag: '🇩🇴' },
  { code: 'JM', name: 'Giamaica', flag: '🇯🇲' },
];

/**
 * Get country by ISO code
 */
export const getCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(c => c.code === code);
};

/**
 * Get multiple countries by ISO codes
 */
export const getCountriesByCodes = (codes: string[]): Country[] => {
  return codes.map(code => getCountryByCode(code)).filter(Boolean) as Country[];
};

/**
 * Search countries by name (case-insensitive)
 */
export const searchCountries = (query: string): Country[] => {
  const lowerQuery = query.toLowerCase();
  return COUNTRIES.filter(c => c.name.toLowerCase().includes(lowerQuery));
};
